import { getCountryCode } from "./Internationalization/handleAppInternationalization";
import { 
    APP, 
    countriesWithMandatoryPOTOSConsent, 
    DASHBOARD, 
    WEB 
} from "../constants/AppConstants";

 // Map enrolmentSource to its payload key
export const consentKeyMap = {
    [WEB]: 'isEmailConsent',
    [APP]: 'isInAppConsent'
};

export function evaluateConsent(params){
    let { consentValue , enrolmentSource,isDashboardInAppValue=undefined} = params;
    let countryCode = getCountryCode();
    let isMandatoryConsentCountry = countriesWithMandatoryPOTOSConsent.indexOf(countryCode) !== -1;

    const defaultDecision = {
        shouldShowBanner:false, 
        shouldUpdate : false
    }

    const evaluateDashboardConsentValue = (consentValue, payloadKey, isDashboardInAppValue) => {
        if ( consentValue  || isDashboardInAppValue) return defaultDecision; 
        return {
                shouldShowBanner:true, 
                shouldUpdate : true, 
                payload : { [payloadKey]: true }
            };
    }

    const evaluateConsentValue = (consentValue, payloadKey) => {
        if ( consentValue === true) return defaultDecision; 
        if (isMandatoryConsentCountry && consentValue === null )
            return {
                shouldShowBanner:false, 
                shouldUpdate : true, 
                payload : { [payloadKey]: true }
            };
        return {
                shouldShowBanner:true, 
                shouldUpdate : false
            };
    }

    switch( enrolmentSource ){
        case WEB :
            return evaluateConsentValue(consentValue, consentKeyMap[WEB]);
        case APP :
            return evaluateConsentValue(consentValue, consentKeyMap[APP]);
        case DASHBOARD :
            return evaluateDashboardConsentValue(consentValue, consentKeyMap[WEB],isDashboardInAppValue);
         default:
            console.error(`Unhandled source: ${enrolmentSource}`);
            return defaultDecision
    }
}

export function buildConsentPayload(params){
    let { userConsent : { emailConsent, appConsent } , enrolmentSource} = params;
    switch( enrolmentSource ){
        case WEB :
            return {payload : { [consentKeyMap[WEB]] : emailConsent }}
        case APP :
            return {payload : { [consentKeyMap[APP]] : appConsent }}
        default:
            console.error(`Unhandled source: ${enrolmentSource}`);
            return { payload: {} };
    }
}